/**
 * Normalize an axios error's `detail` field into a human-readable string.
 *
 * FastAPI returns two shapes under `detail`:
 *   1. A plain string, e.g. { detail: "Invalid email or password" }
 *   2. An array of Pydantic validation-error objects, each like
 *      { type, loc, msg, input, ctx }
 *
 * Passing shape (2) to React (setState + JSX render) crashes with
 * "Objects are not valid as a React child". This helper flattens either
 * shape into a display string so callers can safely do
 * setError(getErrorMessage(err, 'Fallback')).
 */
export function getErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;

  if (!detail) return err?.message || fallback;
  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    const messages = detail
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object') {
          const field = Array.isArray(d.loc) ? d.loc.filter((p) => p !== 'body').join('.') : '';
          const msg = d.msg || d.message || '';
          return field ? `${field}: ${msg}` : msg;
        }
        return '';
      })
      .filter(Boolean);
    if (messages.length) return messages.join(' · ');
  }

  return fallback;
}
